// extracted by mini-css-extract-plugin
export default {"communityCard":"Community_communityCard__L30vP","cards":"Community_cards__bTNg3","infoText":"Community_infoText__LTb5S","picture":"Community_picture__wKDCG"};